"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const dateFns = require('date-fns');
const assert = require('assert').strict;
const { resolveExpression } = require('../evaluate');
const { IN_THE_NEXT } = require('../definitions/operators');
const { DAY, WEEK, MONTH, YEAR } = require('../definitions/durationUnits');
const { generateDateBetweenExpression, } = require('../definitions/factory/expressionFactory');
exports.accepts = ({ operator }) => operator === IN_THE_NEXT;
exports.resolve = ({ right, left }, context) => __awaiter(void 0, void 0, void 0, function* () {
    assert(context);
    assert(right);
    assert(left);
    const { context: { durationUnit }, } = right;
    assert(durationUnit);
    const leftResolved = yield resolveExpression(left, context);
    const rightResolved = yield resolveExpression(right, context);
    const expressionEvaluationDate = new Date(Date.now());
    let beforeDate;
    switch (durationUnit) {
        case DAY:
            beforeDate = dateFns.addDays(expressionEvaluationDate, rightResolved);
            break;
        case WEEK:
            beforeDate = dateFns.addWeeks(expressionEvaluationDate, rightResolved);
            break;
        case MONTH:
            beforeDate = dateFns.addMonths(expressionEvaluationDate, rightResolved);
            break;
        case YEAR:
            beforeDate = dateFns.addYears(expressionEvaluationDate, rightResolved);
            break;
        default:
            throw new Error('Duration unit is not valid');
    }
    const afterValue = expressionEvaluationDate.toISOString();
    const beforeValue = beforeDate.toISOString();
    // In the next returns true when the date to be resolved is between now
    // and the last day in range
    const beforeExpression = generateDateBetweenExpression({
        leftValue: leftResolved,
        afterValue,
        beforeValue,
    });
    return resolveExpression(beforeExpression, context);
});
//# sourceMappingURL=inTheNextExpression.js.map